import { DateTime } from 'luxon';
import React from 'react';
import { Time } from '../../localization/Time';

const EventTime = ({ticketEvents, statusCode, timeZone}) => {
  return <Time date={ticketEvents?.[statusCode]} hideTimeZone={true} timeZone={timeZone} />
}

export default EventTime;
